import { render } from "./Diagram.vue?vue&type=template&id=4e9fae1a&scoped=true"
import script from "./Diagram.vue?vue&type=script&lang=js"
export * from "./Diagram.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4e9fae1a"

export default script